import { useMemo } from "react";

import { observer } from "mobx-react-lite";

import screenFullscreen from "../../assets/images/screen-fullscreen.png";
import { useMeetingDetailsStore } from "../../contexts/meetingDetails/meetingDetailsContext";
import useScheduledDate from "../../hooks/useScheduledDate";

import { MeetingLifecycleHandlers } from "./meeting-lifecycle-handlers";

const MeetingLifecycleViewer = observer(({ meetingStatus, openFullscreen, inFullscreen }) => {
  const { meeting, isJoined, isJoining, isLeaving, joinProgress, joinProgressLength, leaveProgress, joinError, userMediaPermissionsGranted } =
    useMeetingDetailsStore();
  const { formattedDate, endTime, countdown } = useScheduledDate({
    startsAt: meeting?.startsAt,
    endsAt: meeting?.endsAt,
  });

  const { CreatedStatus, StartErrorStatus, PendingStatus, StartedStatus, EndedStatus, DefaultStatusComponent } = MeetingLifecycleHandlers();

  const statusToComponentMap = {
    created: CreatedStatus,
    "start-error": StartErrorStatus,
    starting: PendingStatus,
    started: StartedStatus,
    ending: PendingStatus,
    ended: EndedStatus,
  };

  const StatusComponent = useMemo(() => statusToComponentMap[meetingStatus] || DefaultStatusComponent, [meetingStatus]);

  const isRealPlayerCondition = meetingStatus === "started" && isJoined;
  const shouldRenderStatusComponent = !inFullscreen || isRealPlayerCondition;

  return shouldRenderStatusComponent ? (
    <div className={`${!isRealPlayerCondition ? "full-width-height" : ""}`}>
      <StatusComponent
        meeting={meeting}
        isJoining={isJoining}
        joinProgress={joinProgress}
        joinProgressLength={joinProgressLength}
        isJoined={isJoined}
        isLeaving={isLeaving}
        leaveProgress={leaveProgress}
        joinError={joinError}
        isUserMediaPermissions={userMediaPermissionsGranted}
        formattedDate={formattedDate}
        endTime={endTime}
        countdown={countdown}
        openFullscreen={openFullscreen}
      />
    </div>
  ) : (
    <img src={screenFullscreen} className="fullscreen-image" alt="" />
  );
});

export default MeetingLifecycleViewer;
